import React from 'react';
import Carousel from '../pages/Carousel';
import WideRangeSection from '../pages/WideRangeSection';
import ExploreBrand from '../pages/ExploreBrand';
import ClientSlider from '../pages/ClientSlider';
import AboutUsSection from '../pages/AboutUsSection';
import AdventureSection from '../pages/AdventureSection';
import VehicleFleet from '../pages/VehicleFleet';
import WhyChooseUs from '../pages/WhyChooseUs';
import CategoriesSection from '../pages/CategoriesSection';
import WorkingSteps from '../pages/WorkingSteps';
import TestimonialSectionnn from '../pages/TestimonialSectionnn';
// import TestimonialSection from '../pages/TestimonialSection';
import { Helmet } from 'react-helmet';

const HeroSection = () => {
  return (
<div className=''>
<Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
  <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable" />
  <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Mumbai Cabs",
        description: "Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1500"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sneha Kulkarni"
            },
            "datePublished": "2024-12-22",
            "reviewBody": "Seamless booking process and the ride was very comfortable. Highly recommend AB Ghule Cabs for Pune to Mumbai trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vishal Sharma"
            },
            "datePublished": "2024-12-18",
            "reviewBody": "Great service at an affordable price. The driver was professional and punctual."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-cabs"
        },
        "keywords": "Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way"
      }
    `}
  </script>
</Helmet>
    <Carousel/>
    <WideRangeSection/>
    <ExploreBrand/>
    {/* <ClientSlider/> */}
    {/* <AboutUsSection/> */}
   <AdventureSection/>
   <VehicleFleet/>
   <WhyChooseUs/>
   <CategoriesSection/>
   <WorkingSteps/>
   <TestimonialSectionnn/>

   
   
</div>
  );
};

export default HeroSection;
